'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardAreaMainStyled = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {};
var defaultProps = {};

var CardAreaMainStyled = exports.CardAreaMainStyled = _styledComponents2.default.div.withConfig({
  displayName: 'CardAreaMainStyled'
})(['flex-grow:1;']);

CardAreaMainStyled.propTypes = propTypes;
CardAreaMainStyled.defaultProps = defaultProps;
CardAreaMainStyled.displayName = 'CardAreaMainStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-card/dist/CardAreaMain/styles/CardAreaMainStyled.js
// module id = 583
// module chunks = 0